import { api } from './client'

const trustService = {
  getAccounts: (matterId) => api.get('/trust/accounts', matterId ? { matterId } : {}),
  getTransactions: (accountId, params = {}) => api.get(`/trust/accounts/${accountId}/transactions`, params),
  getSummary: (accountId) => api.get(`/trust/accounts/${accountId}/summary`),
  getBalance: (matterId) => api.get(`/trust/balance/${matterId}`),
}

export default trustService
